import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "./components/ui/card";
import { Button } from "./components/ui/button";
import { CheckCircle, Clock } from 'lucide-react';

const OnboardingSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const type = searchParams.get('type'); // 'candidato' | 'agenzia'
  const status = searchParams.get('status'); // 'pending' | 'approved'

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-emerald-50 p-4">
      <Card className="w-full max-w-md shadow-xl">
        <CardHeader className="text-center bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-t-lg">
          <div className="flex justify-center mb-4">
            {status === 'pending' ? (
              <Clock className="w-16 h-16" />
            ) : (
              <CheckCircle className="w-16 h-16" />
            )}
          </div>
          <CardTitle className="text-2xl">
            {status === 'pending' ? (
              'Richiesta Inviata!'
            ) : (
              'Registrazione completata! Benvenuto su InLeads 🎉'
            )}
          </CardTitle>
          <CardDescription className="text-green-100 mt-2">
            {type === 'candidato' ? 'Candidato' : 'Agenzia'} registrato con successo
          </CardDescription>
        </CardHeader>
        
        <CardContent className="p-6 space-y-4">
          {status === 'pending' ? (
            <div className="space-y-4">
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <div className="flex items-start gap-3">
                  <Clock className="w-5 h-5 text-blue-600 mt-0.5" />
                  <div>
                    <h3 className="font-semibold text-blue-900 mb-1">In Attesa di Approvazione</h3>
                    <p className="text-sm text-blue-700">
                      {type === 'agenzia' ? (
                        <>
                          La tua richiesta è stata inviata al team InLeads.
                          Riceverai una email con le credenziali di accesso una volta che l'account verrà approvato.
                        </>
                      ) : (
                        <>
                          <span>In attesa di approvazione dal team InLeads</span>
                        </>
                      )}
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="text-center text-sm text-gray-600">
                <p>Tempo medio di approvazione: 24-48 ore</p>
              </div>
            </div>
          ) : (
            <div className="space-y-4">
              <p className="text-center text-gray-700">
                Controlla la tua email per le credenziali di accesso.
              </p>
            </div>
          )}

          <div className="flex gap-3 pt-4">
            <Button
              onClick={() => navigate('/')}
              variant="outline"
              className="flex-1"
            >
              Torna alla Home
            </Button>
            {status !== 'pending' && (
              <Button
                onClick={() => navigate('/accesso')}
                className="flex-1 bg-gradient-to-r from-blue-600 to-emerald-600"
              >
                Accedi Ora
              </Button>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default OnboardingSuccess;
